
import * as React from 'react';
import Typography from '@mui/material/Typography';
import { Button, Card, CardActions, CardContent, CardMedia, Container, Divider, Grid, Paper, Stack, styled } from '@mui/material';
import MailOutlineIcon from '@mui/icons-material/MailOutline';


const items = [
    {title:"Contact Us",description:"With our state-of-the-art app, find and reserve your perfect spot in seconds. Say hello to parking bliss!"},
    {title:"Chat",description:"9:30 AM - 8:30 PM EST 7 Days a Week"},
    {title:"Message",description:"ext (618) 867.4225 9:30 AM - 8:30 PM EST 7 Days a Week"},
]

export default function HelpCenter() {
    return (
        <>
            <Container id = "app" maxWidth = {false}  component='main' sx={{background:'linear-gradient(135deg, #ffab00 0%, #ff6f00 50%, #ff8f00 100%);'}}>
                <Divider sx={{my:8}}></Divider>
                <Grid container columns={12} sx={{pt:8}}>
                    <Grid item xs={1} md ={1} sm={1} align="left" />  
                    
                    <Grid item xs={10} md ={5} sm={5} align="left" >  
                        <Stack spacing={2} >
                            <Typography component="p"  variant="h3" color="black" sx={{fontWeight:'bolder'}} >
                            Help Center
                            </Typography>
                            <Typography variant="body1" gutterBottom color="black">
                            Welcome to the Help Center — your go-to resource for everything related to our smart parking system. Whether you need assistance with reservations, access issues, payments, or account management, we're here to help you park smarter, faster, and with confidence.
                            </Typography>
                        </Stack> 
                    </Grid>

                    <Grid item xs={10} md ={5} sm={5} align="right" >  
                        <img
                            width="529"
                            height="615" 
                            src="https://firebasestorage.googleapis.com/v0/b/demos-a64ab.appspot.com/o/landing%2Fagent_ia3.png?alt=media&token=c948287b-f0a9-40e1-93f9-0f1344a42c8f"
                            alt="Live from space album cover"
                        />            
                    </Grid>
                    
                    <Grid item xs={1} md ={1} sm={1} align="left" />  
                </Grid>
            </Container>

            <Container id = "app" maxWidth = {"xl"}  component='main' sx={{py:8}}>  
                <Grid container columns={12} sx={{pt:8,pb:4}} spacing={2}>
                    {items.map(element => (
                    <Grid item xs={12} md ={4} sm={4} align="center" >  
                        <Card  variant='cartoon' sx={{height:"200px"}}>
                           
                            <CardContent>
                                <Typography gutterBottom variant="h5" component="div">
                                    {element.title}
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    {element.description}
                                </Typography>
                            </CardContent>
                            <CardActions sx={{justifyContent:"center"}}>
                                <Button variant='outlined' size="small">Continuar</Button>
                            </CardActions>
                        </Card>
                    </Grid>
                    ))}
                    <Grid item xs={12} md ={6} sm={6} align="center" sx={{height:"200px"}}>  
                        <Card  variant='cartoon'>
                            <CardContent>
                                <Typography gutterBottom variant="h5" component="div">
                                    {"Business"}
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    {"Send us an email with your contact information"}
                                </Typography>
                            </CardContent>
                            <CardActions sx={{justifyContent:"center"}}>
                                <Button variant='outlined' size="small">See More</Button>
                            </CardActions>
                        </Card>
                    </Grid>
                    <Grid item xs={12} md ={6} sm={6} align="center" sx={{height:"200px"}}>  
                        <Card variant='cartoon'>
                            <CardContent>
                                <Typography gutterBottom variant="h5" component="div">
                                    {"Request Or Delete Your Data"}
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    {"9:30 AM - 8:30 PM EST 7 Days a Week"}
                                </Typography>
                            </CardContent>
                            <CardActions sx={{justifyContent:"center"}}>
                                <Button variant='outlined' size="small">Request</Button>
                            </CardActions>
                        </Card>
                    </Grid>
                </Grid>
            </Container>

            <Container id = "app" maxWidth = {"xl"}  component='main'>
              
                <Typography component="p" variant="h4"sx={{fontWeight:'bolder'}}>
                    Do you need something more?
                </Typography>
                <Typography component="p" variant="body" color="text.secondary">
                    You can send us an email to: support@cqurity.com.mx
                </Typography>
            </Container>
        </>
    );
}